import React from "react";
import ApexChart from "react-apexcharts";

const RadialChart = (props) => {
  let { percentage, labels } = props;
  return (
    <div>
      <ApexChart
        options={{
          chart: {
            type: "radialBar",
          },
          plotOptions: {
            radialBar: {
              hollow: {
                margin: -1,
                size: "68%",
                background: "#FFE352",
                position: "front",
              },
              dataLabels: {
                name: {
                  show: false,
                },
                value: {
                  offsetY: 10,
                  color: "#444444",
                  fontSize: "30px",
                  fontWeight: "bold",
                  show: true,

                },
              },
              track: {
                background: "#FFE352",
                position: "back",


              },
            },
          },
          labels: labels,
          colors: ["#FFC15D"],
          states: {
            hover: {
             filter: {
                type: 'none'
              }
            }
          }
        }}
        series={percentage}
        type="radialBar"
        height={250}
      />
    </div>
  );
};

export default RadialChart;
